<div class="login-body">
  <div class="contenedor-login">
    <h1>Restablecer contraseña de red</h1>
    <p class="subtexto">Inicia sesión con tu correo corporativo para continuar el proceso de desbloqueo</p>

    <button class="boton-google" (click)="loginWithGoogle()">
      <svg viewBox="0 0 24 24">
        <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1c-4.3 0-8.01 2.47-9.82 6.07l3.66 2.84C7.7 7.31 10.13 5.38 12 5.38z"/>
        <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09L2.18 7.07C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22z"/>
        <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
        <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31l3.57 2.77C21.36 18.42 22.56 15.6 22.56 12.25z"/>
      </svg>
      <span>Continuar con Google</span>
    </button>
  </div>
</div>
